module.exports = __webpack_public_path__ + "img/users.0e21ae37.svg";